import { render, staticRenderFns } from "./role-manag.vue?vue&type=template&id=30b46e7d&"
import script from "./role-manag.vue?vue&type=script&lang=js&"
export * from "./role-manag.vue?vue&type=script&lang=js&"
import style0 from "./role-manag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports